<!-- eslint-disable vue/multi-word-component-names -->
<!-- Layout filenames are fixed by the house structure spec (Default / Blank / Sidebar /
     Topbar), so the multi-word rule cannot apply to this folder. -->
<template>
    <!-- The window is the frame and only the work scrolls inside it. The navigation and
         the top bar stay where they are: a receptionist scrolling a list of two hundred
         reservations should not have to scroll back up to reach the menu, and a sidebar
         that slides away with the page is a sidebar people stop using. -->
    <div class="app-frame flex h-dvh overflow-hidden bg-muted print:h-auto print:overflow-visible">
        <!-- Two menus for one transition. The new one groups forty entries into
             seven folds and puts settings behind a gear; the classic one is what
             every desk has been using, kept working and unchanged, because a
             navigation somebody has learned is not a thing to take away on a
             Tuesday. Which one is drawn is this browser's own choice (Videz). -->
        <SidebarClassic v-if="classicNav" />
        <Sidebar v-else />

        <div class="flex min-w-0 flex-1 flex-col overflow-hidden print:overflow-visible">
            <Topbar />

            <main class="app-scroll min-w-0 flex-1 overflow-y-auto p-3 sm:p-4 lg:p-6 print:overflow-visible">
                <!-- The tabs of the screen, where the screen is one of a group of them
                     (v1.542.0). It draws nothing on every other screen, and nothing at
                     all on paper. It is above the page and not inside it because the
                     tabs are navigation: which of them is open is the address, and no
                     screen has to know it has siblings.

                     Not with the CLASSIC menu, which still lists every one of these
                     screens on its own and is documented as unchanged: a row of tabs
                     above the page would be the same navigation twice, offered to the
                     people who asked for the menu they already had. -->
                <NavTabs v-if="!classicNav" />

                <slot>
                    <!-- Keyed by the house. Every screen here reads one property's data,
                         and most of them read it once when they are opened — so changing
                         the property in the top bar used to leave whichever screen was
                         open showing the other hotel's rooms, or nothing at all, until
                         somebody navigated away and back.

                         Remounting throws away the filters on that screen, which is the
                         right trade: they were filters over another hotel. -->
                    <RouterView :key="appStore.propertyId" />
                </slot>
            </main>
        </div>
        <!-- Mounted once, outside the sidebar, because Ctrl+K has to work on every
             screen and the classic menu has no search entry of its own. -->
        <NavSearch />
    </div>
</template>

<script lang="ts" setup>
    import NavSearch from '@/layouts/components/NavSearch.vue'
    import NavTabs from '@/layouts/components/NavTabs.vue'
    import Sidebar from '@/layouts/components/Sidebar.vue'
    import SidebarClassic from '@/layouts/components/SidebarClassic.vue'
    import Topbar from '@/layouts/components/Topbar.vue'
    import { useNav } from '@/libs/nav'
    import { useAppStore } from '@/stores/app'

    const appStore = useAppStore()

    const { classicNav } = useNav()
</script>
